import React from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import { TeaserFragment } from './types/TeaserFragment'

type Props = {
  className?: string
} & TeaserFragment

export default function StoryCard({
  title,
  image,
  rectangularImage,
  slug,
}: Props) {
  const fallbackBackgrounds = [
    'bg-green-lightest',
    'bg-blue-light opacity-25',
    'bg-magenta-light opacity-50',
    'bg-BgSub',
  ]

  return (
    <Link
      to={`/nutrition-explained/${slug}`}
      className={cn(
        'block flex-1 ml-20 md:ml-0',
        'shadow-elevated border-1 border-Border',
        'rounded-8 lg:rounded-12 transition',
        'hover:border-grey-lighter'
      )}
    >
      <div>
        <div className="rounded-t-8 lg:rounded-t-12 overflow-hidden relative">
          <div
            className={`absolute inset-0 ${
              fallbackBackgrounds[
                Math.floor(Math.random() * fallbackBackgrounds.length)
              ]
            }`}
          />
          {image && (
            <img
              src={rectangularImage?.url}
              alt={image.alt || undefined}
              width="240"
              height="160"
              className="relative"
            />
          )}
        </div>
        <p className="my-8 mx-12 lg:my-12 lg:mx-16 type-small text-Type leading-body">
          {title}
        </p>
      </div>
    </Link>
  )
}
